import React from "react";
import { label } from "../../config";
import { useWorkflowContext } from "../Workflow/WorkflowContextProvider";
import VariableConfiguration from "../Workflow/WorkflowVariables/VariablesConfiguration/VariableConfiguration";
import FormElementPropertiesPanel from "./Properties/FormElementPropertiesPanel";
import SubsectionProperties from "./Properties/SubsectionProperties";
import ShowIfSection from "./ShowIfSection";
import { useFormInteraction } from "./contexts/FormInteractionContext";
import "./styles/FieldProperties.scss";

/**
 * Right-hand sidebar: variable config, subsection props, or selected element field props.
 * @param {Object} props
 * @param {function(string|number, Object): void} props.onFieldPropertiesChange
 * @param {function(Object): void} props.onSubsectionPropertiesChange
 * @param {Array} [props.usedWorkflowVariableIds]
 * @param {function(string): void} [props.onRemoveElementByVariableId]
 * @param {Object} [props.formData]
 * @param {string|number} [props.formId]
 */
const FormPropertiesWrapper = ({
  onFieldPropertiesChange,
  onSubsectionPropertiesChange,
  usedWorkflowVariableIds,
  onRemoveElementByVariableId,
  formData,
  formId,
}) => {
  const { selectedElement, selectedSubsection, setSelectedSubsection } = useFormInteraction();
  const { selectedVariable } = useWorkflowContext();

  const renderPropertiesContent = () => {
    if (selectedVariable) {
      return (
        <VariableConfiguration
          isFormVariable
          usedWorkflowVariableIds={usedWorkflowVariableIds}
          onRemoveFromForm={onRemoveElementByVariableId}
          formData={formData}
          formId={formId}
          handleShowIfChange={handleShowIfChange}
        />
      );
    }

    if (selectedSubsection) {
      return (
        <SubsectionProperties // SubsectionProperties component
          subsection={selectedSubsection}
          onChange={onSubsectionPropertiesChange}
          handleShowIfChange={handleShowIfChange}
        />
      );
    }

    return (
      <FormElementPropertiesPanel
        selectedElement={selectedElement}
        onFieldPropertiesChange={onFieldPropertiesChange}
        usedWorkflowVariableIds={usedWorkflowVariableIds}
        handleShowIfChange={handleShowIfChange}
      />
    );
  };

  const handleShowIfChange = (elementId, elementValue) => {
    if (selectedElement) {
      onFieldPropertiesChange(elementId, { ...elementValue, type: "showIf" });
    } else if (selectedSubsection) {
      onSubsectionPropertiesChange?.(selectedSubsection?.id, { ...elementValue });
    }
  };

  return (
    <aside className='form-builder-sidebar form-properties-container d-flex flex-column overflow-y-auto'>
      <div className='sidebar-section border-bottom'>
        <h3 className='section-title'>{label.PROPERTIES}</h3>
        <div>{renderPropertiesContent()}</div>
      </div>
    </aside>
  );
};

export default FormPropertiesWrapper;
